import { useEffect, useRef } from 'react';
import { TAB_IDS } from '../constants/app';

/**
 * Auto-selects the document tab the first time a session gains a generated
 * document, unless the user has already switched tabs, the SOAP notes tab is
 * hidden, or the caller gates it off. Fires at most once per mount.
 *
 * @param params.enabled Caller gate; when false the effect never runs. Default true.
 */
export function useAutoSelectDocumentTab(params: {
  enabled?: boolean;
  documentsLength: number;
  hideSoapNotesTab: boolean;
  userSwitchedTabRef: { current: boolean };
  setActiveTab: (tab: string) => void;
}): void {
  const {
    enabled = true,
    documentsLength,
    hideSoapNotesTab,
    userSwitchedTabRef,
    setActiveTab,
  } = params;
  const didAutoSelectDocRef = useRef(false);

  useEffect(() => {
    if (
      enabled !== false &&
      documentsLength > 0 &&
      !userSwitchedTabRef.current &&
      !didAutoSelectDocRef.current &&
      !hideSoapNotesTab
    ) {
      setActiveTab(TAB_IDS.document);
      didAutoSelectDocRef.current = true;
    }
  }, [
    enabled,
    documentsLength,
    hideSoapNotesTab,
    setActiveTab,
    userSwitchedTabRef,
  ]);
}
